import {REGRequiredStates} from '@deliveriesondemand/dod-data';
import {connect} from 'react-redux';
import {Component} from 'react';
import PropTypes from 'prop-types';
import mixpanel from 'mixpanel-browser';

import {renderFieldErrors} from '-/util/util';
import Step from '-/components/general/Step';
import VehicleInfoService from '-/services/VehicleInfoService';
import UIService from '-/services/UIService';
import NavigationService from '-/services/NavigationService';
import ApiService from '-/services/ApiService';
import DealInfoService from '-/services/DealInfoService';
import IdentifyVehicle from '-/components/fields/IdentifyVehicle';
import {getVinVehicleInfo} from '-/util/util';
import {get} from '-/util/lodash';

class VehicleInfo extends Component {
    static propTypes = {
        onSaveAndExitClick: PropTypes.func,
        onReviewClick: PropTypes.func
    };

    static defaultProps = {
        onSaveAndExitClick: () => {},
        onReviewClick: () => {}
    };

    constructor(props) {
        super(props);

        this.state = {
            disableButtons: false,
            vehicleProps: {},
            vehicleState: {
                errorMessages: []
            },
            showErrors: false
        };

        this.onPreviousClick = this.onPreviousClick.bind(this);
        this.onNextClick = this.onNextClick.bind(this);
        this.onSaveAndExitClick = this.onSaveAndExitClick.bind(this);
        this.onReviewClick = this.onReviewClick.bind(this);
    }

    onClickIfValid(fn) {
        const {vehicleState = {}} = this.state;
        const {errorMessages = []} = vehicleState;
        const invalidVinError = 'VIN Invalid';

        this.setState({showErrors: true});

        if (errorMessages.length <= 0) {
            fn();
        } else {
            if (errorMessages.indexOf(invalidVinError) > -1) {
                mixpanel.track(invalidVinError);
            }
        }
    }

    onSaveAndExitClick() {
        const {vehicleState} = this.state;
        const {collectNewDealInfo = false} = vehicleState;
        const {onSaveAndExitClick} = this.props;

        onSaveAndExitClick(['vehicleInfo', ...collectNewDealInfo ? ['dealInfo'] : []]);
    }

    onPreviousClick() {
        const {onPreviousClick} = this.props;
        this.onClickIfValid(onPreviousClick);
    }

    onAddReminder = async(extraStipTransportType, stipType) => {
        VehicleInfoService.set('extraStipTransportType', extraStipTransportType);
        const {vehicleProps} = this.state;
        let {hasVinReminder, hasRegReminder} = vehicleProps;
        const stipTypes = stipType.split(',');

        if (stipTypes.includes('VIN')) {
            hasVinReminder = true;
        }

        if (stipTypes.includes('REG')) {
            hasRegReminder = true;
        }

        NavigationService.set('hasVinReminder', hasVinReminder);
        NavigationService.set('hasRegReminder', hasRegReminder);

        VehicleInfoService.closeDialog();
        await this.saveVehicleInfo();

        VehicleInfoService.set('extraStipTransportType', null);
        NavigationService.set('setVinReminder', hasVinReminder);
        NavigationService.set('setRegReminder', hasRegReminder);
    };

    onNextClick() {
        this.onClickIfValid(() => {
            const {isDealer, isRateDropPromoActive} = this.props;
            const {vehicleProps} = this.state;

            let {
                vin,
                dialogData,
                extraStipTransportType,
                hasVinReminder,
                hasRegReminder,
                knowRegistrationState,
                registrationState
            } = vehicleProps;

            const showVinDialog = !isDealer && !vin && !hasVinReminder && !extraStipTransportType;
            const showRegDialog = !isDealer && !hasRegReminder && knowRegistrationState === 'yes' && REGRequiredStates.includes(registrationState);
            const stipType = [];

            if (showVinDialog) {
                stipType.push('VIN');
            }

            if (showRegDialog) {
                stipType.push('REG');
            }

            if (!isDealer && isRateDropPromoActive) {
                stipType.push('OLD');
            }

            dialogData = {
                ...dialogData,
                stipType: stipType.join(',')
            };
            if (stipType.length) {
                VehicleInfoService.openDialog(dialogData, this.onAddReminder);
                return;
            }

            this.saveVehicleInfo();
        });
    }

    onReviewClick() {
        const {onReviewClick} = this.props;
        this.onClickIfValid(onReviewClick);
    }

    onVehicleTypeChange = () => {
        // reset error state when switching between options
        this.setState({showErrors: false});
    }

    saveVehicleInfo() {
        const {collectNewDealInfo = false, vehicleProps: vehicleInfo} = this.state;
        const parts = ['vehicleInfo', ...collectNewDealInfo ? ['dealInfo'] : []];
        const vinVehicleInfo = getVinVehicleInfo(vehicleInfo);

        VehicleInfoService.set('vinVehicleInfo', vinVehicleInfo);

        return ApiService.save(parts).then(() => {
            const isCashDeal = DealInfoService.isCashDeal();
            const nextStep = isCashDeal ? 'finalReview' : 'employmentInfo';

            UIService.stepCompleted('vehicleInfo');
            NavigationService.next(nextStep);
        }).catch(ex => ex);
    }

    handleVehicleChange = props => {
        const {vehicleProps, vehicleState} = props;

        this.setState({
            vehicleProps,
            vehicleState
        });
    };

    handleInvalidateSubmission = props => {
        const {isInvalid} = props;

        this.setState({
            disableButtons: isInvalid
        });
    };

    getErrorMessages = () => {
        const messages = [];

        return messages;
    };

    onInputChange = () => {
        setTimeout(() => {
            const messages = this.getErrorMessages();
            const {vehicleState} = this.state;

            this.setState({
                vehicleState: {
                    ...vehicleState,
                    errorMessages: messages
                }
            });
        }, 0);
    }

    render() {
        const {apiErrors = []} = this.props;
        const {disableButtons, showErrors, vehicleState = {}} = this.state;
        const {errorMessages} = vehicleState;

        return (
            <Step
                disableButtons={disableButtons}
                onSaveAndExitClick={this.onSaveAndExitClick}
                onPreviousClick={this.onPreviousClick}
                onNextClick={this.onNextClick}
                onReviewClick={this.onReviewClick}>
                
                <IdentifyVehicle
                    handleInvalidateSubmission={this.handleInvalidateSubmission}
                    handleVehicleChange={this.handleVehicleChange}
                    onVehicleTypeChange={this.onVehicleTypeChange}
                    showErrors={showErrors} />
                {showErrors ? renderFieldErrors([...errorMessages, ...apiErrors]) : null}
            </Step>
        );
    }
}

const mapStateToProps = state => {
    const isRateDropPromoActive = get(state, 'config.isRateDropPromoActive', false);
    const dealType = get(state, 'creditor.type', 'creditUnion');
    const apiErrors = ApiService.getErrors();

    return {
        apiErrors,
        isCU: dealType === 'creditUnion',
        isDealer: dealType === 'dealer',
        isRateDropPromoActive
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onPreviousClick: () => {
            dispatch(() => {
                NavigationService.next('buyerInfo');
                ApiService.save('none');
            });
        },
        onSaveAndExitClick: parts => {
            ApiService.explicitSave(parts);
        },
        onReviewClick: () => {
            NavigationService.next('finalReview');
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(VehicleInfo);
